export class CardDataEvent
{
    static ID_CHANGED: string = 'CardDataEvent.ID_CHANGED';
    static TITLE_CHANGED: string = 'CardDataEvent.TITLE_CHANGED';
    static WIDTH_CHANGED: string = 'CardDataEvent.WIDTH_CHANGED';
    static HEIGHT_CHANGED: string = 'CardDataEvent.HEIGHT_CHANGED';
    static Z_INDEX_CHANGED: string = 'CardDataEvent.Z_INDEX_CHANGED';
    static TYPE_CHANGED: string = 'CardDataEvent.TYPE_CHANGED';
    static SELECTED_CHANGED: string = 'CardDataEvent.SELECTED_CHANGED';
    static PAINT_CHANGED: string = 'CardDataEvent.PAINT_CHANGED';
    static META_TYPE_CHANGED: string = 'CardDataEvent.META_TYPE_CHANGED';
    static FLIPPED_CHANGED: string = 'CardDataEvent.FLIPPED_CHANGED';
    static FACE_SRC_CHANGED: string = 'CardDataEvent.FACE_SRC_CHANGED';
    static BACKFACE_SRC_CHANGED: string = 'CardDataEvent.BACKFACE_SRC_CHANGED';
    static BACKFACE_PAINT_CHANGED: string = 'CardDataEvent.BACKFACE_PAINT_CHANGED';
}
